import { Component, Input, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ComponentService, CreatorFrontApi } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-coupon',
	templateUrl: './coupon.component.html',
	styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@Input() emailRegExp: any;
	@ViewChild('couponForm', { static: true }) couponForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	couponFormSubscription: Subscription;
	defaultChanged = false;
	isAdmin;
	newVariable;
	background_type;
	font;
	fonts: Array<Font>;
	emailError;
	emailRemovalError = false;
	dbCountTotal;
	dbCountAssigned;
	dbCountAvailable;
	couponCountSubscription;

	constructor(
		private comService: ComponentService,
		private overlay: OverlayService,
		private fontsService: FontsService,
		private sanitation: DomSanitizer,
		private auth: AuthService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.dbCountTotal =
			this.dbCountAssigned =
			this.dbCountAvailable =
				this.sanitation.bypassSecurityTrustHtml('<i class="fas fa-sync fa-spin" style="font-size:90%;color:#212529;"></i>');

		if (this.componentID != -1) {
			this.checkCoupons();
		}

		if ((this.isAdmin && this.componentID != -1) || this.componentData.config.remove) {
			this.componentData.config.remove = {
				csv: '',
				include_assigned: false,
				notify_removal_only: false,
				email: ''
			};
		}

		this.emailError = this.componentData.config.email ? false : true;
		this.background_type = this.componentData.config.background['background-image'] ? 'Image' : 'Color';
		this.fonts = this.fontsService.getFonts();

		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.text.font;

		this.couponFormSubscription = this.couponForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.couponForm.dirty && this.couponForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.couponForm.dirty && this.couponForm.valid),
				debounceTime(2000)
			)
			.subscribe((data) => {
				//    this.brodcastToPreview()
				this.defaultChanged = true;
			});
	}

	ngOnDestroy() {
		this.couponFormSubscription.unsubscribe();
		if (this.couponCountSubscription) {
			this.couponCountSubscription.unsubscribe();
		}
	}

	resetBackground(type) {
		if (type == 'color') {
			this.componentData.config.background['base-background-image'] = this.componentData.config.background['background-image'];
			this.componentData.config.background['background-image'] = '';
		} else {
			if (
				this.componentData.config.background['base-background-image'] != '' &&
				this.componentData.config.background['base-background-image']
			) {
				this.componentData.config.background['background-image'] = this.componentData.config.background['base-background-image'];
			}
		}
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	onImageChange(event) {
		const u = String(event && event.url);
		this.componentData.config.background['background-image'] = u;
	}

	addCSV() {
		if (this.componentData.config.csv_list.length < 20) {
			this.componentData.config.csv_list.push('');
		} else {
			this.overlay.updateOverlay(true, 'You have reached the limit of 20 CSV files', 'alert');
		}
	}

	removeCSV(index) {
		this.componentData.config.csv_list.splice(index, 1);
	}

	emailCheck() {
		const emails = this.componentData.config.email.split(',').map((item) => item.trim());
		this.emailError = false;
		for (const email of emails) {
			const valid = this.emailRegExp.test(email);
			if (!valid) {
				this.emailError = true;
			}
		}
	}

	emailRemovalCheck() {
		const valid = this.emailRegExp.test(this.componentData.config.remove.email);
		if (!valid) {
			this.emailRemovalError = true;
		}
	}

	checkCoupons() {
		const data = {
			name: this.componentData.name,
			legacy: this.componentData.legacy,
			config: JSON.stringify(this.componentData.config),
			data: JSON.stringify({ widgetId: this.componentID })
		};

		this.couponCountSubscription = this.comService.checkCouponCounts(data).subscribe(
			(response: CreatorFrontApi) => {
				if (response && response.status) {
					if (response.data) {
						this.dbCountTotal = response.data.total;
						this.dbCountAvailable = response.data.available;
						this.dbCountAssigned = this.dbCountTotal - this.dbCountAvailable;
					} else {
						this.dbCountTotal = 'n/a';
						this.dbCountAssigned = 'n/a';
						this.dbCountAvailable = 'n/a';
					}
					this.cd.detectChanges();
				}
			},
			(err) => {
				this.dbCountTotal = 'n/a';
				this.dbCountAssigned = 'n/a';
				this.dbCountAvailable = 'n/a';
				this.cd.detectChanges();
			}
		);
	}
}
